"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "GraphExamine___StyledSvg",
  componentId: "sc-1r7o1mp-0"
})(["color:", ";height:", ";width:", ";font-size:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
}, function (p) {
  return p._css4;
});

function GraphExamine(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size,
    _css4: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.566 6.283V3.428H3.428v12.849h6.067v1.427H3.428A1.43 1.43 0 012 16.277V3.427C2 2.64 2.64 2 3.428 2h8.147l3.274 3.273v2.793h-1.428V6.283h-2.855zm-5.71 7.854h3.436a4.605 4.605 0 01-.225-1.428H6.282v-.418l1.428-1.428.543.543c.142-.488.363-.949.655-1.364l-.693-.692a.714.714 0 00-1.009 0l-.923.922v-2.56H4.855v6.425zm10.826.535a3.542 3.542 0 00.595-1.964 3.573 3.573 0 00-3.57-3.57 3.573 3.573 0 00-3.569 3.57 3.574 3.574 0 003.57 3.569c.726 0 1.4-.222 1.965-.596L16.99 18 18 16.99l-2.318-2.318zm-2.974.177c-1.181 0-2.142-.96-2.142-2.141 0-1.182.96-2.142 2.142-2.142 1.18 0 2.141.96 2.141 2.142 0 1.18-.96 2.141-2.141 2.141z",
    fill: "currentColor"
  }));
}

var _default = GraphExamine;
exports["default"] = _default;